<template>
  <div id="app">
    <router-view />
    <footer class="app-footer">
      <a href="https://beian.miit.gov.cn/" target="_blank" class="icp-text">
        <span class="icp-text">浙ICP备2024062069号-1</span>
      </a>
      <a 
            href="https://xhslink.com/m/96XmZgiwyxN" 
            target="_blank" 
            class="author-link"
          >
            @西西的奇思妙想
          </a>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.bgcolor {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

/* ICP 备案 Footer 样式 */
.app-footer {
  padding: 5px 5px;
  text-align: center;
  background: transparent;
  margin-top: auto;
}

.icp-text {
  margin: 0;
  font-size: 10px;
  color: #0f0d0d;
  line-height: 1.5;
  text-decoration: none;
  opacity: 0.7;
  transition: all 0.3s ease;
}

a.icp-text {
  display: inline-block;
}

a.icp-text:hover {
  color: #1c1b1b;
  opacity: 1;
}

.author-link {
  margin: 0;
  font-size: 10px;
  color: #0f0d0d;
  line-height: 1.5;
  text-decoration: none;
  opacity: 0.7;
  transition: all 0.3s ease;
}

a.author-link {
 
}

a.author-link:hover {
  color: #1c1b1b;
  opacity: 1;
}
</style>
